export default "__VITE_ASSET__BubDLUTl__"